/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type LazyImageWrapper_item$ref = any;
export type LazyImageWrapper_item = {
    readonly photos: ReadonlyArray<{
        readonly placeholder: string | null;
    } | null> | null;
    readonly " $refType": LazyImageWrapper_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "LazyImageWrapper_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "photos",
      "storageKey": "photos(limit:1)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        }
      ],
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "placeholder",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '66b63b781be0b9150b305761f2aac314';
export default node;
